(function () {
  var TARGET_URL = 'https://sextoycolombia.com/pages/crear-solicitud-mayorista';

  function normalize(s) {
    s = (s || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
    // quitar tildes (si el navegador soporta)
    try {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    return s;
  }

  function isMatchText(txt) {
    txt = normalize(txt);
    return (txt === 'conviertete en mayorista' || txt === 'conviertete mayorista' || txt === 'mayoristas');
  }

  function setHref(a) {
    if (!a || !a.getAttribute) return false;
    var href = a.getAttribute('href') || '';
    if (href !== TARGET_URL) a.setAttribute('href', TARGET_URL);

    // por si algún JS te lo vuelve a cambiar, forzamos en click
    if (!a.__stcMayoristaBound) {
      a.__stcMayoristaBound = true;
      a.addEventListener('click', function (e) {
        try { e.preventDefault(); } catch (err) {}
        window.location.href = TARGET_URL;
      }, true);
    }
    return true;
  }

  function fixLinks() {
    var anchors = document.querySelectorAll('a');
    if (!anchors || !anchors.length) return;

    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var txt = (a.textContent || '').trim();

      // 1) match por texto del botón
      if (isMatchText(txt)) {
        setHref(a);
        continue;
      }

      // 2) match por aria-label (a veces Dawn lo usa)
      var aria = a.getAttribute('aria-label') || '';
      if (isMatchText(aria)) {
        setHref(a);
        continue;
      }
    }
  }

  // Ejecutar ya y re-ejecutar por si el menú se renderiza después
  function boot() {
    fixLinks();

    // Reintentos rápidos (menú drawer carga después)
    var tries = 0;
    var t = setInterval(function () {
      fixLinks();
      tries++;
      if (tries >= 20) clearInterval(t);
    }, 300);

    // MutationObserver para cambios de DOM (drawer/sections)
    try {
      var obs = new MutationObserver(function () { fixLinks(); });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}

    // Al abrir drawer suele cambiar el DOM
    document.addEventListener('click', function () { setTimeout(fixLinks, 50); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
